import { Form, Row } from 'antd';
import React from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import DatePickerComponent from 'components/atoms/DatePickerComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import FormWrapper from 'components/molecules/FormWrapper';

import { useDateLimit } from 'hooks/statniSprava/useDateLimit';
import { useFormBasics } from 'hooks/statniSprava/useFormBasics';

import numberValidation from 'utils/validations/numberValidation';

import AlertComponent from './AlertComponent';
import OdeslaniPozadavkuRows from './odeslaniPozadavkuRows';

interface IF58 {}

const F58: React.FC<IF58> = () => {
    const [form] = Form.useForm();
    const [, dateLoading, commonDisabledDate] = useDateLimit();
    const [
        errMsg,
        currentStep,
        idSluzby,
        upozorneni,
        loading,
        odeslaniResp,
        setErrMsg,
        prev,
        onFormSubmit,
        showPxKlicLoadingMsg
    ] = useFormBasics();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        const dataToSend = {
            ...fieldsValue,
            dtod: fieldsValue.dtod.format('YYYY-MM-DD'),
            dtdo: fieldsValue.dtdo.format('YYYY-MM-DD')
        };
        onFormSubmit(dataToSend);
    };

    return (
        <LoadingWrapper loading={loading} loadingText={showPxKlicLoadingMsg ? 'LOADING_PXKLIC' : 'NACITANI'}>
            <Title level={4} text="DUVERNE_INFO_TITLE_F58" />
            {errMsg ? (
                <>
                    <Paragraph text={errMsg} />
                    <Row>
                        <ButtonComponent
                            id="f58ZpetBtn"
                            type="default"
                            buttontext="ZPET"
                            onClick={() => setErrMsg('')}
                        />
                    </Row>
                </>
            ) : (
                <>
                    {currentStep !== 2 ? (
                        <FormWrapper onFinish={onFinish} outForm={form}>
                            <>
                                <LoadingWrapper loading={dateLoading}>
                                    <DatePickerComponent
                                        name="dtod"
                                        label="ME_POZADAVKY_DATUM1"
                                        disabled={currentStep > 0}
                                        disabledDate={current =>
                                            current > form.getFieldValue('dtdo') || commonDisabledDate(current)
                                        }
                                    />
                                    <DatePickerComponent
                                        name="dtdo"
                                        disabled={currentStep > 0}
                                        label="ME_POZADAVKY_DATUM2"
                                        disabledDate={current =>
                                            current < form.getFieldValue('dtod') || commonDisabledDate(current)
                                        }
                                    />
                                </LoadingWrapper>
                                <InputComponent
                                    label="ME_POZADAVKY_CISLO_PPN"
                                    name="rliv"
                                    maxLength={12}
                                    disabled={currentStep > 0}
                                    rules={numberValidation()}
                                />

                                {currentStep === 0 && (
                                    <ButtonComponent
                                        id="f58OdeslatBtn"
                                        buttontext="ODESLAT"
                                        onClick={() => form.submit()}
                                    />
                                )}
                                {currentStep !== 0 && upozorneni && (
                                    <AlertComponent
                                        upozorneni={upozorneni}
                                        type={currentStep === 1 ? 'error' : 'info'}
                                    />
                                )}
                                {currentStep === 1 && (
                                    <Row className="button-row">
                                        <ButtonComponent
                                            id="f58ZpetAltBtn"
                                            buttontext="ZPET"
                                            onClick={() => prev()}
                                            type="default"
                                        />
                                        <ButtonComponent
                                            id="f58PotvrditBtn"
                                            buttontext="POTVRDIT"
                                            onClick={() => form.submit()}
                                        />
                                    </Row>
                                )}
                            </>
                        </FormWrapper>
                    ) : (
                        <>
                            <OdeslaniPozadavkuRows idSluzby={idSluzby} datum={odeslaniResp?.datum} />
                            {upozorneni && <AlertComponent upozorneni={upozorneni} type={'info'} />}
                        </>
                    )}
                </>
            )}
        </LoadingWrapper>
    );
};

export default F58;
